import React from "react";
import PropTypes from "prop-types";

const Bar = (props) => {
  const width = `${props.percent}%`;
  return (
    <div
      style={{
        ...props.style,
      }}
    >
      <div
        className="transition-width"
        style={{
          backgroundColor: props.style.color,
          height: 8,
          width,
          borderRadius: 4,
        }}
      />
    </div>
  );
};

Bar.propTypes = {
  percent: PropTypes.number,
};

Bar.defaultProps = {
  percent: 1,
};

export default Bar;
